<script>
    import NoGapProgramRule from "./NoGapProgramRule.svelte";
    import {
        NotificationModal
    } from "../../../Components/Common/index.svelte";
    import {
        addIcon
    } from "../../../Utils/utilConstants.svelte";

    export let specialRules = [], mbsItems = [], selectedInsuranceFund, hospitalFundNoGapProgramNames;
    let specialRuleRefs = [];
    let isDeleteRuleModalOpen = false;
    let selectedRuleIndex = null;

    const addRule = () => {
        specialRules = [
            ...specialRules,
            {
                id: 0,
                itemNums: [],
                rebateType: null,
                unitValue: 0,
                upliftRebate: null
            }
        ];
    }

    const removeRule = (indexToRemove) => {
        specialRules = specialRules.filter((_, index) => index !== indexToRemove);
    }
    
    let errInputs = [];

    export const checkNoGapProgramSpecialRulesValidation = () => {
        errInputs = [];
        for (const ruleRef of specialRuleRefs) {
            const ruleCheckErrors = ruleRef.checkNoGapProgramRuleValidation();
            errInputs = [...errInputs, ...ruleCheckErrors];
        }

        return errInputs;
    };

   
</script>

<div class="w-full flex flex-col justify-center gap-y-3">
    <div class="w-full flex flex-row justify-between items-center">
        <p>Special case rules:</p>
        <div on:click={addRule} class="flex flex-row gap-2 items-center cursor-pointer hover:rounded-full hover:bg-secondary hover:text-white pl-4 pr-4" data-tip="Add rule">
            <i class="deleteIcon {addIcon}"></i> Add
        </div>
    </div>
    <div class="w-full flex flex-col gap-2 min-h-[200px] p-1">
        {#if specialRules.length == 0}
            <div class="w-full p-2">No special rules defined</div>
        {/if}
        {#each specialRules as rule, index (index)}
            <NoGapProgramRule
                identifier={index}
                bind:hospitalFundNoGapProgramNames={hospitalFundNoGapProgramNames}
                bind:this={specialRuleRefs[index]}
                mbsItems={mbsItems}
                bind:itemNums={rule.itemNums}
                bind:rebateType={rule.rebateType}
                bind:unitValue={rule.unitValue}
                bind:upliftRebate={rule.upliftRebate}
                bind:selectedInsuranceFund={selectedInsuranceFund}
                onRemove={() => {
                        isDeleteRuleModalOpen = true;
                        selectedRuleIndex = index;
                    }
                }
            />
        {/each}
    </div>
</div>

<NotificationModal
    isModalOpen={isDeleteRuleModalOpen}
    title={`DELETE Special rule`}
    closeModalFunction={() => { isDeleteRuleModalOpen = false; }}
    showCancelBtn={false}
    showConfirmBtn={false}
    modalMaxWidth={'w-[800px] max-w-4xl'}
    btnOptions={[
        {
            text: "Cancel",
            class: "btn-accent",
            function: () => { isDeleteRuleModalOpen = false },
        },
        {
            text: "Confirm",
            class: "btn-secondary",
            function: () => { 
                //delete the rule
                removeRule(selectedRuleIndex)
                isDeleteRuleModalOpen = false;
            },
        },
    ]}
>
    <div class="flex flex-col flex-1 p-4 gap-y-4 ">
        <p>
            You are about to delete selected special rule from this no gap program.
        </p>
        <p>Are you sure to confirm this action?</p>
    </div>
</NotificationModal>




